import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import {
  InfoElement,
  InfoWrapper,
  InfoBlock,
  ViewContainer,
} from './employee-interview-details-view.styles';

const EmployeeInterviewDetailsView = ({ data }: { data: any }) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <ViewContainer>
      <InfoWrapper>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">
              {t('employee:employeeInterview.labels.employeeInterviewName')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.interviewName || '-'}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">
              {t('employee:employeeInterview.labels.interviewType')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.interviewType.name}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('common:labels.creationDate')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {moment(data.createdAt).format('DD.MM.YYYY')}
            </Typography>
          </InfoElement>
        </InfoBlock>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">{t('employee:labels.createdBy')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.createdByMember.profile.displayName}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('employee:employeeInterview.labels.setTo')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {moment(data.setTo).format('DD.MM.YYYY')}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('common:labels.status')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {t(`employee:employeeInterview.statuses.${data.status.toLowerCase()}`).toLowerCase()}
            </Typography>
          </InfoElement>
        </InfoBlock>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">
              {t('employee:employeeInterview.labels.feedback')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.feedback || '-'}
            </Typography>
          </InfoElement>
        </InfoBlock>
      </InfoWrapper>
      <div>
        {data.interviewArticles.map(({ headline, description }: any, index: number) => (
          <InfoElement key={index}>
            <Typography weight="bold">{headline}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {description || '-'}
            </Typography>
          </InfoElement>
        ))}
      </div>
    </ViewContainer>
  );
};

export default EmployeeInterviewDetailsView;
